/* ORENOA premium (05/10/2026) : lien « Guía de tamaños » de la fiche.
   Au clic, la galerie affiche l'image de comparaison des tailles (texte alternatif « Comparaison des tailles »,
   « Comparación de tamaños » ou « Size comparison ») et la fait défiler à l'écran. Sans cette image, le lien est masqué. */
(function () {
  var RX = /comparaison|comparaci[oó]n|comparison|gu[ií]a de tama|size guide/i;
  function findCompare(root) {
    var scope = (root && root.closest && root.closest('.shopify-section')) || document;
    var gallery = scope.querySelector('media-gallery') || document.querySelector('media-gallery');
    if (!gallery) return null;
    var slides = gallery.querySelectorAll('slideshow-slide');
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      if (img && RX.test(img.getAttribute('alt') || '')) return { gallery: gallery, index: i, slide: slides[i] };
    }
    return null;
  }
  function refresh() {
    document.querySelectorAll('[data-oa-size-guide]').forEach(function (btn) {
      btn.hidden = !findCompare(btn);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-oa-size-guide]');
    if (!btn) return;
    e.preventDefault();
    var hit = findCompare(btn);
    if (!hit) return;
    var show = hit.gallery.querySelector('slideshow-component');
    try { if (show && typeof show.select === 'function') show.select(hit.index); } catch (err) {}
    var top = hit.gallery.getBoundingClientRect().top + window.scrollY - 80;
    if (Math.abs(hit.gallery.getBoundingClientRect().top) > 120 || window.innerWidth < 750) {
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
  });
  var queued = false;
  function queue() { if (queued) return; queued = true; setTimeout(function () { queued = false; refresh(); }, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();
